import './index.less';
import * as React from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import useDelayedFlag from '@src/utils/hooks/use-delayed-flag';
import CommonLoading from '@src/components/common-loading';
import Page from '@src/components/page';
import MoGuestPage from '@src/ui-components/mo-guest-page';
import GuestStore from './store';

const styles = require('./index.less');

const GuestContent = () => {
  const { activitySessionStore } = React.useContext(MobXProviderContext);
  const store = useStore(() => new GuestStore({ activitySessionStore }));

  // 短于 300ms 的加载不渲染遮罩：缓存命中/快速响应不闪屏，慢请求照常出现
  const showLoading = useDelayedFlag(store.loadStatus === 'loading');
  return (
    <Page className={styles.root}>
      <MoGuestPage
        members={store.members}
        inviter={store.inviter}
        joined={store.joined}
        joinDisabled={store.joinDisabled}
        createDisabled={store.createDisabled}
        onJoin={store.handleJoinClick}
        onContinueInvite={store.handleContinueInvite}
        onCreateTeam={store.handleCreateTeamClick}
      />
      {store.accountInfoStore.getComponent()}
      {showLoading ? (
        <div className={styles.loading} data-name="Guest加载中">
          <CommonLoading />
        </div>
      ) : null}
    </Page>
  );
};

const ObservedGuestContent = observer(GuestContent);

const Guest = () => <ObservedGuestContent />;

export default Guest;
